import { createContext } from 'react';

const LoyaltyProgramsContext = createContext(null);

export default LoyaltyProgramsContext;
